import React, { useState } from 'react';
import { GroupMeetingScreen } from './GroupMeetingScreen';
import { MobileGuestMeetingScreen } from './MobileGuestMeetingScreen';
import { AppSettings } from '../types';

interface MobileGuestHubScreenProps {
  settings: AppSettings;
  initialTab?: 'group' | 'podcast';
  initialRoomCode?: string;
  onMeetingRecorded?: (blob: Blob, durationSec: number, title: string, thumbnailUrl?: string) => void;
}


export const MobileGuestHubScreen: React.FC<MobileGuestHubScreenProps> = ({
  settings,
  initialTab,
  initialRoomCode,
  onMeetingRecorded
}) => {
  const [activeTab, setActiveTab] = useState<'group' | 'podcast'>(() => {
    if (initialTab) return initialTab;
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      if (params.get('mode') === 'group-meeting' || params.get('meet') || params.get('group') || initialRoomCode) {
        return 'group';
      }
      if (params.get('mode') === 'guest' || params.get('code')) {
        return 'podcast';
      }
      return (localStorage.getItem('meetsplit_mobile_guest_tab') as 'group' | 'podcast') || 'group';
    }
    return 'group';
  });

  const handleTabChange = (tab: 'group' | 'podcast') => {
    setActiveTab(tab);
    try {
      localStorage.setItem('meetsplit_mobile_guest_tab', tab);
    } catch {}
  };

  return (
    <div className="w-screen h-[100dvh] overflow-hidden flex flex-col bg-[#0a0f1d]">
      {activeTab === 'group' ? (
        <GroupMeetingScreen
          settings={settings}
          onNavigate={() => {}}
          initialRoomCode={initialRoomCode}
          isMobileGuest={true}
          activeGuestTab="group"
          onSwitchGuestTab={handleTabChange}
          onMeetingRecorded={onMeetingRecorded}
        />
      ) : (
        <MobileGuestMeetingScreen
          isMobileGuestHub={true}
          activeGuestTab="podcast"
          onSwitchGuestTab={handleTabChange}
        />
      )}
    </div>
  );
};
